import React from 'react';
import { hydrate } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';

import { loadableReady } from '@loadable/component';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};

// render app with server props to the DOM
loadableReady(() => {
    hydrate(<App {...props} />, document.getElementById('root'));
});

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
